export const localStorageSelector = (key: string) => {
  return localStorage.getItem(key)
}
